/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {ContactId, ContactInput, SupplierId} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getAddSupplierContactUrl = (id: SupplierId) => {
  return `/api/v1/engineering/suppliers/${id}/contacts`;
};

/**
 * @summary Add supplier contact
 */
export const addSupplierContact = async (
  id: SupplierId,
  contactInput: ContactInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<ContactId> => {
  return customFetch<ContactId>(getAddSupplierContactUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(contactInput),
  });
};

export const getEditSupplierContactUrl = (id: SupplierId, contactId: ContactId) => {
  return `/api/v1/engineering/suppliers/${id}/contacts/${contactId}`;
};

/**
 * @summary Edit supplier contact
 */
export const editSupplierContact = async (
  id: SupplierId,
  contactId: ContactId,
  contactInput: ContactInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getEditSupplierContactUrl(id, contactId), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(contactInput),
  });
};

export const getRemoveSupplierContactUrl = (id: SupplierId, contactId: ContactId) => {
  return `/api/v1/engineering/suppliers/${id}/contacts/${contactId}`;
};

/**
 * @summary Remove supplier contact
 */
export const removeSupplierContact = async (
  id: SupplierId,
  contactId: ContactId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveSupplierContactUrl(id, contactId), {
    ...options,
    method: "DELETE",
  });
};
